import { z } from 'zod';
import {
  BaseElementSchema,
  PointSchema,
} from '@/components/canvas/document/schema/elementBase';

export const ImageElementSchema = BaseElementSchema.extend({
  type: z.literal('image'),
  data: z.object({
    src: z.string(),
    objectFit: z.enum(['contain', 'cover', 'fill', 'none', 'scale-down']).optional().default('cover'),
    objectPosition: PointSchema.optional(),
    imageScale: z.number().optional(),
  }),
});
